/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 17:00:29
 * @FilePath: /vise/packages/app-share/src/services/fetch-rec-feeds/index.ts
 */
import { AjaxConfig } from '@tencent/wsl-ajax';
import { TRPC_CALL_PATH, TRPC_CALL_TEST_PATH } from '@/constants/url';
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { getReqHeader } from '@/utils/request';
import { checkIsTestEnvAndInBrowser } from '@/utils/env';
import { IHashMap } from '@/types/data';
import { ModelMetaFeed } from '@/types/model';
import { FetchRecFeedsReq, FetchRecFeedsRsp } from '@/types/services/fetch-rec-feeds';
import { formatFeed } from '@/utils/formatter';

const getUrl = () => (checkIsTestEnvAndInBrowser() ? TRPC_CALL_TEST_PATH : TRPC_CALL_PATH);

type FetchResult = {
  attachInfo: string,
  recommendTags: IHashMap,
  recommendFeeds: ModelMetaFeed []
};

/**
 *
 * 获取推荐feed流
 * @export
 * @param
 * @return {*}  {(Promise<FetchResult | null>)}
 */
export default async function fetchRecFeed(params: FetchRecFeedsReq): Promise<FetchResult | null> {
  const fetchConfig: AjaxConfig = {
    url: `${getUrl()}/H5GetPlayPageNew`,
    withCredentials: true,
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    responseType: 'json',
    data: JSON.stringify({
      req_body: params,
      req_header: getReqHeader(),
    }),
  };
  try {
    const wslAjax = await loadWslAjaxAsync();
    if (!wslAjax) return null;
    const { request } = wslAjax;
    const res = (await request<FetchRecFeedsRsp>(fetchConfig))?.rsp_body;
    if (res) {
      return {
        attachInfo: res.attachInfo,
        recommendTags: res.recommendtags,
        recommendFeeds: res.recommendfeeds.map((feed, index) => formatFeed(feed, index)),
      };
    };
  } catch (err) {
    console.error('接口fetchRecFeed出现了一些问题');
  };
  return null;
}
